module.exports = __webpack_public_path__ + "img/palette-1_fg_jp.71ecc52.jpg";